import React, { useEffect, useState } from "react";
import { CheckCircle2, XCircle, Loader2, RefreshCw } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const WaStatus = ({ onTemplates }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const [phone, setPhone] = useState("");
  const [testing, setTesting] = useState(false);
  const test = async () => {
    setTesting(true);
    try { const r = await api.post("/wa-groups/test", { phone }); toast.success(r.data.note); } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    setTesting(false);
  };
  const check = async () => {
    setBusy(true);
    try { const r = await api.get("/wa-groups/status"); setS(r.data); onTemplates(r.data.templates || []); } catch { setS({ ok: false, error: "Could not check" }); }
    setBusy(false);
  };
  useEffect(() => { check(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const approved = (s?.templates || []).filter((t) => t.status === "APPROVED").length;

  return (
    <Card className={`p-4 border ${s?.ok ? "border-[#25D366]/50 bg-[#25D366]/5" : "border-red-400/40 bg-red-500/5"}`} data-testid="wa-status-card">
      <div className="flex items-start gap-3">
        {busy || !s ? <Loader2 className="w-5 h-5 animate-spin text-gold mt-0.5" /> : s.ok ? <CheckCircle2 className="w-5 h-5 text-[#25D366] mt-0.5" /> : <XCircle className="w-5 h-5 text-red-300 mt-0.5" />}
        <div className="flex-1 text-sm">
          <p className="font-semibold" data-testid="wa-status-text">{!s ? "Checking Gupshup account…" : s.ok ? "Gupshup account connected" : "Gupshup account not working"}</p>
          {s?.ok && <p className="text-xs text-emerald-100/70 mt-0.5" data-testid="wa-status-details">App {s.app} · number +{String(s.number).replace(/\D/g, "")} · {approved} approved template{approved === 1 ? "" : "s"} of {s.templates.length}</p>}
          {s && !s.ok && <p className="text-xs text-red-200 mt-0.5" data-testid="wa-status-error">Gupshup says: {s.error}</p>}
        </div>
        <Button size="sm" variant="outline" onClick={check} disabled={busy} data-testid="wa-status-recheck" className="h-8 gap-1"><RefreshCw className="w-3.5 h-3.5" /> Check again</Button>
      </div>
      <div className="flex flex-wrap gap-2 mt-3 pl-8">
        <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Your WhatsApp number" data-testid="wa-test-phone" className="h-8 max-w-[220px] bg-card/60" />
        <Button size="sm" onClick={test} disabled={testing || !phone.trim()} data-testid="wa-test-send" className="h-8 bg-[#25D366] text-[#06140f] hover:bg-[#25D366]/90">{testing ? "Sending…" : "Send test message"}</Button>
        <span className="text-[11px] text-emerald-100/50 self-center">Tip: first send “Hi” from your phone to +1 711-738-9757, then tap Send test.</span>
      </div>
    </Card>
  );
};
